import React, { FC } from 'react'
import styles from './Button.module.scss'

//Icons
import iconDown from './assets/arrow-down.svg'
import sunGrayIcon from './assets/sun-gray.svg'

import {IconMJB, IconType as IconTypeSrc} from './assets/Icons'


export type styleType = 'contained'| "outlined"|'primary' | 'secondary' | 'tertiary' | "bordered" | "icon-contained" | "dashboard-btn" | "dashboard-btn-outlined"
export type iconType = IconTypeSrc
export type Size = 'small' | 'medium' | 'large'
  


export default interface ButtonV2Props {
    name?: string;
    RightIconRender?: FC
    LeftIconRender?: FC
    onClick:React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    variant?: styleType;
    label?: string;
    isActive?: boolean;
    children?: React.ReactNode;
    color?: 'primary' | 'secondary' | 'tertiary' | 'white' ;
    style?: React.CSSProperties;
    type?: "submit" | "reset" | "button",
    iconRightType?: iconType
    iconLeftType?: iconType
    size ?: Size
    fullWidth?: boolean
    height?: number,
    spaceBetween?: boolean

    
}
export default function ButtonV2({
    name,
    RightIconRender,
    LeftIconRender,
    onClick,
    disabled,
    variant = 'contained',
    label,
    children,
    type,
    color,
    iconRightType,
    iconLeftType,
    style, 
    size = 'small',
    fullWidth,
    height,
    isActive, spaceBetween
}:ButtonV2) {


    const styleFormated = {...style, height: height}

  return (
    <button 
        style={styleFormated}
        className={[
            styles['button'],
            styles['button--'+variant],
            styles['button--'+variant+'--'+color+(isActive ? '--active' : '')],
            styles['button--'+color], styles['button--'+size],
            (spaceBetween? styles['button--space-between'] : ''),
            disabled ? styles['button--disabled'] : null,
            fullWidth ? styles['button--full-width'] : null  ].join(" ")}
        name={name}
        onClick={onClick}
        disabled={disabled}
        type={type}

     
    >
        

        {LeftIconRender &&  <div className={[styles['button__icon'], styles['button__icon--left'],  styles['button__icon--left--'+size]  ].join(" ")}> <LeftIconRender /> </div>}
        {iconLeftType &&  <div className={[styles['button__icon'], styles['button__icon--left'],  styles['button__icon--left--'+size]  ].join(" ")}>{ getIcon(iconLeftType, size, undefined, isActive)} </div>}
        <div className={[styles['button__label'], styles['button__label--'+variant]].join(" ")}>
        {children || label}
        </div>
       
        {RightIconRender &&  <div className={[styles['button__icon'], styles['button__icon--right'], styles['button__icon--right--'+size]  ].join(" ")}> <RightIconRender /> </div>}
        {iconRightType &&  <div className={[styles['button__icon'], styles['button__icon--right'],  styles['button__icon--right--'+size]  ].join(" ")}> {getIcon(iconRightType, size, undefined, isActive)} </div>}

        </button>
  )
}

export const getIcon = (iconType: iconType, size?: Size, isHover?: boolean, isActive?: boolean) => {
    switch (iconType) {
        case 'arrow-down':
            return <Icon iconType={iconType}  size={size} src={iconDown} />

        default:
            return  <IconV2 iconType={iconType}  size={size} src={sunGrayIcon} color={isActive ? 'white' : undefined} />
    }
}

export const Icon = ({iconType, size, src }: {iconType: iconType, size?: Size, src?: string}) => {
    return <img className={[styles['icon-item'], styles['icon-item--'+size], styles['icon-item--'+iconType]].join(" ")}src={src} alt="icon" />
}
export const IconV2 = ({iconType, size, src, color }: {iconType: iconType, size?: Size, src?: string, color?: string}) => {
    return (<div className={[styles['icon-item'], styles['icon-item--'+size], styles['icon-item--'+iconType]].join(" ")} 
    ><IconMJB typeIcon={iconType as any} color={color}/></div>)
}
